export default "__VITE_ASSET__acfb4e0f__"